import { forecastDetachedHouseProjectTypes, energyProjectTypes, transmissionProjectTypes } from './../TableData';
export function getProjectTypeSelectOptions(AllLists: any) {
    return AllLists?.executeGetRawProjectTypes.map((type) => ({
        value: type.RawProjectType,
        text: type.RawProjectType
    })) ?? []
}

export function getProjectTypeSelectOptionsAssumption(AllLists: any) {
    return AllLists?.executeGetRawProjectTypes.filter(type => [...energyProjectTypes, ...transmissionProjectTypes, ...forecastDetachedHouseProjectTypes].indexOf(type.RawProjectType) === -1).map((type) => {
        return ({
            value: type.RawProjectType,
            text: type.RawProjectType
        })
    }) ?? []
}

export const integerRegex = /^\d*$/;
export const escalationRateRegex = /^-?\d*(\.\d?)?$/;
